import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import ExtraPelanggansEditor from "@/components/spb/ExtraPelanggansEditor";

// Section 03 · Tujuan Pengiriman — nama pelanggan (with master/history
// typeahead), alamat, and extra recipients editor.
export default function PelangganSection({
  form, setF,
  suggestions, suggestOpen, setSuggestOpen, applySuggestion,
}) {
  return (
    <div className="border border-border p-6 bg-card">
      <div className="overline mb-4">03 · Tujuan Pengiriman</div>
      <div className="grid grid-cols-1 gap-4">
        <div>
          <Label className="overline block mb-2">Nama Pelanggan *</Label>
          <div className="relative">
            <Input
              value={form.nama_pelanggan}
              onChange={(e) => { setF({ nama_pelanggan: e.target.value }); setSuggestOpen(true); }}
              onFocus={() => setSuggestOpen(true)}
              onBlur={() => setTimeout(() => setSuggestOpen(false), 150)}
              className="rounded-lg h-11"
              placeholder="Nama toko / proyek / penerima"
              data-testid="input-nama-pelanggan"
              autoComplete="off"
              required
            />
            {suggestOpen && suggestions.length > 0 && (
              <div
                className="absolute z-20 left-0 right-0 top-full mt-1 border border-border bg-card shadow-lg max-h-72 overflow-y-auto"
                data-testid="pelanggan-suggest-list"
              >
                <div className="px-3 py-1.5 overline bg-secondary/60 border-b border-border text-[10px]">
                  Master Pelanggan &amp; Riwayat
                </div>
                {suggestions.map((s, i) => (
                  <button
                    type="button"
                    key={`${s.nama_pelanggan}-${i}`}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => applySuggestion(s)}
                    className="w-full text-left px-3 py-2 hover:bg-primary/10 border-b border-border/50 last:border-b-0 block"
                    data-testid={`pelanggan-suggest-item-${i}`}
                  >
                    <div className="text-sm font-semibold truncate flex items-center gap-2">
                      {s.nama_pelanggan}
                      {s.source === "master" && (
                        <span className="inline-block border border-emerald-400/60 bg-emerald-50 text-emerald-800 text-[9px] font-bold uppercase tracking-wider px-1 py-0.5">
                          Master
                        </span>
                      )}
                    </div>
                    <div className="text-xs text-muted-foreground truncate">{s.alamat_pengiriman || <em>Belum ada alamat</em>}</div>
                    <div className="text-[10px] font-mono text-muted-foreground mt-0.5">
                      {s.source === "master"
                        ? (s.telepon ? `Tel: ${s.telepon}` : "Dari Master Pelanggan")
                        : (s.count > 1 ? `${s.count}× dipakai (riwayat)` : "1× dipakai (riwayat)")}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        <div>
          <Label className="overline block mb-2">Alamat Pengiriman *</Label>
          <Textarea
            value={form.alamat_pengiriman}
            onChange={(e) => setF({ alamat_pengiriman: e.target.value })}
            className="rounded-lg min-h-[80px]"
            placeholder="Alamat lengkap lokasi bongkar"
            data-testid="input-alamat-pengiriman"
            required
          />
        </div>

        {/* Extra recipients (max 2 → total 3 with primary above) */}
        <ExtraPelanggansEditor
          items={form.extra_pelanggans}
          onChange={(next) => setF({ extra_pelanggans: next })}
        />
      </div>
    </div>
  );
}
